var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalNumberOfFacilitiesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 27.3981H1M26.5 27.3981L16.363 29.955C16.1419 30.0107 15.9112 30.0147 15.6883 29.967C15.4654 29.9192 15.2563 29.8208 15.0767 29.6792C14.8971 29.5377 14.7519 29.3567 14.652 29.1501C14.552 28.9434 14.5001 28.7165 14.5 28.4866V4.02725C14.5003 3.56731 14.6044 3.11197 14.8045 2.69871C15.0045 2.28545 15.2952 1.92362 15.6545 1.64068C16.0138 1.35774 16.4322 1.16113 16.8781 1.06578C17.3239 0.970427 17.7854 0.978838 18.2275 1.09037L24.2275 2.60423C24.8765 2.76795 25.4527 3.14592 25.8644 3.67805C26.2762 4.21018 26.4999 4.86594 26.5 5.5411V27.3981ZM26.5 27.3981H31M14.5 3.17646H10C9.20435 3.17646 8.44129 3.49545 7.87868 4.06326C7.31607 4.63106 7 5.40117 7 6.20417V27.3981M19 15.2873H19.015",
    stroke: "#1290E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalNumberOfFacilitiesIcon);
export default __webpack_public_path__ + "static/media/total-number-of-facilities-icon.32dd9a1221743baff4f79592d82a9a86.svg";
export { ForwardRef as ReactComponent };